// @ts-check
// Ícone de informação do cartão de relatório (contrato 07, seção 7.6), que substituiu o texto "Ajuda" do painel
// antigo. A explicação abre num balão no clique, no toque e no foco pelo teclado, e também ao passar o mouse: uma dica
// nativa (title) não aparece no celular nem pelo teclado.
import { html } from 'htm/preact';
import { useId, useRef, useState } from 'preact/hooks';
import { Icon } from '../../ui/icon.js';
import { Dropdown } from '../../ui/dropdown.js';
import { t } from '../../i18n/index.js';

/**
 * @param {{ text: string }} props
 */
export function WidgetDescription({ text }) {
  const anchorRef = useRef(/** @type {HTMLButtonElement | null} */ (null));
  const [isOpen, setIsOpen] = useState(false);
  // aberto pelo mouse em cima: fecha quando o mouse sai; aberto por clique, toque ou teclado: fica até sair dali
  const [isHoverOnly, setIsHoverOnly] = useState(false);
  const popoverId = `widget-description-${useId()}`;

  const close = () => {
    setIsOpen(false);
    setIsHoverOnly(false);
  };

  return html`<button
      type="button"
      ref=${anchorRef}
      class="widget-card-description"
      aria-label=${t('reports.descriptionLabel')}
      aria-expanded=${isOpen ? 'true' : 'false'}
      aria-describedby=${isOpen ? popoverId : undefined}
      data-active=${isOpen ? 'true' : undefined}
      onClick=${() => {
        if (isOpen && !isHoverOnly) close();
        else {
          setIsOpen(true);
          setIsHoverOnly(false);
        }
      }}
      onFocus=${(/** @type {FocusEvent} */ event) => {
        // só o foco do teclado abre: o clique também dá foco, e abriria e fecharia na mesma hora
        if (/** @type {HTMLElement} */ (event.currentTarget).matches(':focus-visible')) setIsOpen(true);
      }}
      onBlur=${close}
      onPointerEnter=${(/** @type {PointerEvent} */ event) => {
        if (event.pointerType !== 'mouse' || isOpen) return;
        setIsOpen(true);
        setIsHoverOnly(true);
      }}
      onPointerLeave=${(/** @type {PointerEvent} */ event) => {
        if (event.pointerType === 'mouse' && isHoverOnly) close();
      }}
    >
      <${Icon} name="IconInfoCircle" size=${14} />
    </button>
    <${Dropdown} anchorRef=${anchorRef} isOpen=${isOpen} onClose=${close} placement="bottom-end" width=${280} role="tooltip" id=${popoverId}
      className="widget-description-popover">
      <p class="widget-description-text">${text}</p>
    <//>`;
}
